var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1265 4.5H31.727L21.677 15.9375L33.5 31.5H24.242L16.9925 22.0605L8.696 31.5H4.091L14.8415 19.2675L3.5 4.5H12.992L19.547 13.128L27.1265 4.5ZM25.5125 28.758H28.0625L11.606 7.098H8.87L25.5125 28.758Z",
    fill: "#4C89FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCX);
export default __webpack_public_path__ + "static/media/c_x.d424a631d9844bdcf88b9bf8e6a87eca.svg";
export { ForwardRef as ReactComponent };